import React from 'react'

import { P } from '@mxenabled/mxui'

import { SxProps } from '@mui/material'
import CardContent from '@mui/material/CardContent'

import ClientConfigurableCta from './ClientConfigurableCta'

import { Beat } from '../../../types/CommonBeat'

interface DescriptionProps {
  beat: Beat
  hasFullWidthImage?: boolean
  sx?: SxProps
}

export const Description: React.FC<DescriptionProps> = ({ beat, hasFullWidthImage, sx }) => {
  const { html_description } = beat

  return (
    <CardContent
      sx={{
        p: 0,
        '&:last-child': {
          pb: 0,
        },
        pb: 24,
        ...sx,
      }}
    >
      <P
        dangerouslySetInnerHTML={{ __html: html_description! }}
        sx={{
          m: 0,
          pt: 16,
          px: 8, // The new description design has a 24px padding on the x axis, however, pulse already adds 16px. In order to not break existing insights we are only using 8px here so it adds up to 24. Once all insights are moved to this repo we make pulse 0px and this 24px.
          ...(hasFullWidthImage && { px: 16 }),
        }}
        variant="subtitle2"
      />
      <ClientConfigurableCta beat={beat} />
    </CardContent>
  )
}
